import * as Sentry from "@sentry/vue"
import Vue from 'vue'
import VueRouter from 'vue-router'

import i18n from "./i18n/index.js"
import router from './router/index.js'
import App from './app.vue'
import Nav from './nav.vue'
import Tracker from './tracker.vue'
import Session from './session.vue'
import CardPopup from './card-popup.vue'
import ErrorReporting from './error-reporting.vue'
import CancelSubscription from './cancel-subscription.vue'
import UserSubscriptions from './user-subscriptions.vue'
import SliderComments from './slider-comments.vue'
import Footer from './static-content-components/Footer.vue'
import Button from './static-content-components/Button.vue'
import Navigation from './static-content-components/Navigation.vue'
import ModalComponent from './static-content-components/Modals/ModalComponent.vue'
import PaymentModal from './static-content-components/Modals/PaymentModal.vue'
import FeaturesList from './static-content-components/FeaturesList.vue'

import "./modules/subscription/components/components-register.js"
import "./modules/landing/components/components-register.js"
import "./modules/profile/components/components-register.js"
import "./modules/terms/components-register.js"
import "./modules/paywall/components/components-register.js"
import "./modules/subscriptions/components/components-register.js"
import Spinner from "./static-content-components/Spinner.vue";

/* Register components */
Vue.component('navbar', Nav)
Vue.component('tracker', Tracker)
Vue.component('session', Session)
Vue.component('error-reporting', ErrorReporting)
Vue.component('card-popup', CardPopup)
Vue.component('cancel-subscription', CancelSubscription)
Vue.component('user-subscriptions', UserSubscriptions)
Vue.component('custom-button', Button)
Vue.component('custom-footer', Footer)
Vue.component('slider-comments', SliderComments)
Vue.component('navigation', Navigation)
Vue.component('payment-modal', PaymentModal)
Vue.component('modal-component', ModalComponent)
Vue.component('features-list', FeaturesList)
Vue.component('spinner', Spinner)

Vue.use(VueRouter)

Sentry.init({
  Vue,
  dsn: "https://328993eb1a627b32b9701fe015d38ad7@o4508359630716928.ingest.de.sentry.io/4508444656861264",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  allowUrls: [/^https:\/\/(?!localhost)/, /^http:\/\/(?!localhost)/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

new Vue({
  el: '#app',
  data: {
    sessionUrl: null
  },
  router,
  i18n,
  render: function (h) {
    this.sessionUrl = document.body.getAttribute('data-session-url')
    return h(App)
  }
})
